import create from 'zustand'
import to from 'await-to-js'

import API from '~components/API'

// Puts search client in global scope we can use to interact with later without instantiating again
const useRecommendedScenarios = create((set, get) => ({
  loading: true,
  fetched: false,
  recommendedScenarios: [],
  fetch: async () => {
    // If we already have recommended scenarios or have tried previously
    if (get().recommendedScenarios.length > 0 || get().fetched) return

    // Otherwise, kicks things off
    set({ loading: true })

    // Send off API request
    const [error, success] = await to(API.get('/scenarios/recommended'))

    // If data is returned, set data to store
    if (success) {
      set({ recommendedScenarios: success.data })
    } else {
      // eslint-disable-next-line no-console
      console.error(error.message)
    }

    // Resolve loading state and set `fetched` flag to avoid trying to grab again
    set({ fetched: true, loading: false })
  },
}))

export default useRecommendedScenarios
